<template>
  <panel>
    <option-list-item
      v-for="(option, index) in options"
      :key="`option_${index}`"
      :option="option"
      :entity-type="entityType"
      :entity-id="entityId"
    >
      <span slot="index">{{ index + 1 }}.</span>

      <hr />
    </option-list-item>
  </panel>
</template>

<script>
import Panel from '@/components/panel/Panel';

import OptionListItem from './optionList/OptionListItem';

export default {
  components: { OptionListItem, Panel },
  props: {
    // Opcje
    options: {
      type: Array,
      required: true
    },
    // Typ encji
    entityType: {
      type: String,
      required: true
    },
    // Identyfikator encji
    entityId: {
      type: String,
      required: true
    }
  }
};
</script>
